import { GameType } from '__generated__/graphql'
export const NOTIFICATION_TOAST_INIT_TITLE = 'INIT'

/** Token a mode pays its results in, where the result payload does not say. */
export const GAME_RESULT_CURRENCY: Partial<Record<GameType, string>> = {
  [GameType.Bullseye]: 'USDT'
}
